export const useDefaultData = ({ Helpers }) => {

    const { getCurrentDate } = Helpers

    const defaultFormGlobal = {
        idcredito: 0,
        idcotizacion: 0,
        idcliente: 0,
        credito_fecha: getCurrentDate(),
        credito_dia_pago: '',
        monto_venta: '',
        saldo_financiar: '',
        monto_enganche: '',
        enganche: '',
        interes_total: '',
        interes: '',
        plazo: '',
        plazo_anios: '',
        gps: '',
        seguro: '',
        otros: '',
        total_cuota: '',
        cuota_niv: '',
        aprobacion_check: '',
        aprobacion_observaciones: '',
        aprobacion_fecha: getCurrentDate(),
        files: [],
        fileRejections: [],
        acceptedFiles: [],

        clean_monto_venta: 0,
        clean_saldo_financiar: 0,
        clean_monto_enganche: 0,
        clean_gps: 0,
        clean_seguro: 0,
        clean_otros: 0,
        clean_total_cuota: 0,
        clean_cuota_niv: 0,
        costo_papeleria: '',
        clean_costo_papeleria: 0,
    }

    const optionsAprobacionCheck = [
        { value: 'Aprobado', label: 'Aprobado' },
        { value: 'Rechazado', label: 'Rechazado' },
        { value: 'Pendiente Aprobacion', label: 'Pendiente Aprobacion' },
        { value: 'Devuelto a Gestor', label: 'Devuelto a Gestor' },
    ];


    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormDeposit = {
        iddeposit: '',
        idcaja: '',
        idbanco: '',
        boleta_numero: '',
        boleta_foto_path: '',
        boleta_foto_originalname: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        deposito_dolares: '',
        deposito_fecha: getCurrentDate(),
        deposito_moneda: '',
        deposito_monto: '',
        deposito_observaciones: '',
        deposito_quetzales: '',
        deposito_tipo_cambio: 7.8,
        movimiento_tipo: '',
        aprobacion_check: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],

        clean_deposito_monto: 0,
        clean_deposito_quetzales: 0,
        clean_deposito_dolares: 0,
    }

    const defaultFormCollateral = {

        idcollateral: 0,
        title: '',
        type_collateral: '',
        estate: '',
        folio: '',
        department: '',
        book: '',

        valor: '',
        marca: '',
        modelo: '',
        linea: '',
        color: '',
        matricula: '',
        chasis: '',
        description: '',

        clean_valor: 0,
    }

    const defaultFormExpense = {
        idgasto: 0,
        idcredito: 0,
        gasto_fecha: getCurrentDate(),
        gasto_descripcion: '',
        gasto_monto: '',
        usuario_creo: '',
        fecha_creo: '',
        usuario_modifico: '',
        fecha_modifico: '',
        clean_gasto_monto: '',
    }

    const optionsTypeMoneda = [
        { value: 'QUETZAL', label: 'QUETZAL' },
        { value: 'DOLAR', label: 'DOLAR' },
    ];

    const optionsTypePayment = [
        { value: 'EFECTIVO', label: 'EFECTIVO' },
        { value: 'DEPOSITO', label: 'DEPOSITO' },
    ];

    const optionsAprobacionDeposit = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'PENDIENTE', label: 'PENDIENTE' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
    ];

    const optionsTypeCollateral = [
        { value: 'BIEN INMUEBLE', label: 'BIEN INMUEBLE' },
        { value: 'VEHICULO', label: 'VEHICULO' },
        { value: 'PRENDA', label: 'PRENDA' },
    ];

    const defaultFormInsuranceRenewal = {
        seguro: '',
        fecha_ren_seguro: '',
        cuotas_restantes: 0,
        total_seguro: 0,
        cuota_nuevo_seguro: 0,
        check_cuotas: false,


        clean_total_seguro: 0,
    }

    const defaultFormGPSRenewal = {
        gps: '',
        fecha_ren_gps: '',
        cuotas_restantes: 0,
        total_gps: 0,
        cuota_nuevo_gps: 0,
        check_cuotas: false,


        clean_total_gps: 0,
    }



    return Object.freeze({
        defaultFormGlobal,
        optionsAprobacionCheck,
        defaultDataModal,
        defaultFormDeposit,
        optionsTypeMoneda,
        optionsTypePayment,
        optionsAprobacionDeposit,
        defaultFormCollateral,
        optionsTypeCollateral,
        defaultFormExpense,
        defaultFormInsuranceRenewal,
        defaultFormGPSRenewal,
    })
}